import { createSelector } from 'reselect'
import { REDUX_STATUS } from '@gymaholic/packages'
import { getSearchDomainListSectionSelector } from 'modules/section/selectors/getSearchDomainList/index.js'

/**
 * Search items based on the given section and query (from the store).
 * @param  {string} section
 */
export function isSearchLoadedSectionSelector (section) {
  return createSelector(
    getSearchDomainListSectionSelector({ section }),
    (
      domainList
    ) => {
      return (
        !!domainList?.data &&
        domainList?.status !== REDUX_STATUS.LOADING
      )
    }
  )
}
